import { getBreadcrumbs } from "@/utils/http-calls";

export default {
	name: "BreadcrumbableMixin",

	data: () => ( {
		bcFetchRequest: []
	} ),

	computed: {
		breadcrumbs: {
			get() {
				return this.$store.state.breadcrumbs.breadcrumbs;
			},
			set( breadcrumbs ) {
				return this.$store.dispatch( "breadcrumbs/set", breadcrumbs );
			}
		}
	},

	methods: {
		addDynamicBreadcrumbs( requestData ) {
			return getBreadcrumbs( requestData )
			.then( breadcrumbs => {
				requestData.forEach( info => {
					const route = this.$router.options.routes[info.routerIndex];
					const responseProp = breadcrumbs[info.route];

					this.breadcrumbs.splice( info.bcIndex, 0, {
						text: route.meta.bcText( responseProp ),
						to: {
							name: route.name,
							params: typeof route.props === "function"
								? route.props( this.$route )
								: route.props
						}
					} );
				} );
			} );
		},

		genBreadcrumbs( route ) {
			const bcFetchRequest = [];

			if ( route.meta && route.meta.structure ) {
				const routes = this.$router.options.routes;

				route.meta.structure.forEach( ( routerIndex, bcIndex ) => {
					const structureRoute = routes[routerIndex];

					if ( structureRoute.meta.hasOwnProperty( "bcFetch" ) ) {
						const request = typeof structureRoute.meta.bcFetch === "function"
							? structureRoute.meta.bcFetch( route.params )
							: structureRoute.meta.bcFetch;

						request.bcIndex = bcIndex;
						request.routerIndex = routerIndex;

						bcFetchRequest.push( request );
					} else if ( structureRoute.meta.hasOwnProperty( "bcText" ) ) {
						this.breadcrumbs.push( {
							text: structureRoute.meta.bcText,
							to: { name: structureRoute.name }
						} );
					}
				} );

				if ( bcFetchRequest.length ) {
					this.addDynamicBreadcrumbs( bcFetchRequest );
				}
			}
		},

		clearBreadcrumbs() {
			this.$store.dispatch( "breadcrumbs/clear" );
			this.$store.dispatch( "breadcrumbs/clearDetails" );
		}
	},

	created() {
		this.clearBreadcrumbs();
		this.genBreadcrumbs( this.$route );
	},

	beforeDestroy() {
		this.clearBreadcrumbs();
	}
};
